"use client";

import Link from "next/link";
import type { MouseEvent } from "react";

import type { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import styles from "./houseBrandMenu.module.scss";

export const HOUSE_BRAND_TITLE = "About House Brand";

// What House Brand means, shown in the overlay drawer.
export default function HouseBrandMenu({ closeCallback }: OverlayMenuBaseProps) {
  // The drawer stays open across client-side navigation, so a plain click closes it. A modified click opens a new tab.
  const closeOnPlainClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey || event.button !== 0) {
      return;
    }
    closeCallback?.();
  };

  return (
    <div className={styles.HouseBrandMenu} data-house-brand-drawer>
      <section className={styles.topic}>
        <h3 className={styles.heading}>What is “House Brand”?</h3>
        <p>
          House Brand is not a specific name brand. House Brand is used so vendors can offer their best deal on the
          surplus products they have on hand. Though the actual manufacturers may vary, these products always meet the
          specifications in the product description.
        </p>
      </section>
      <section className={styles.topic}>
        <h3 className={styles.heading}>Advantages of House Brand</h3>
        <p>
          By granting vendors flexibility regarding brands, they can fulfill orders more efficiently and offer more
          competitive prices.
        </p>
      </section>
      <p>
        Regardless of the brand you ultimately receive, Net32 stands by its{" "}
        <a href="/guarantee" className={styles.link}>
          30-Day Money Back Guarantee
        </a>
        .
      </p>
      <p>
        If you have any further questions, please contact our{" "}
        <Link href="/contact-us" prefetch={false} className={styles.link} onClick={closeOnPlainClick}>
          Customer Support Team
        </Link>
        .
      </p>
    </div>
  );
}
